import { RECEIVING_ITEM_REASON_DATA } from '../actions/actionType'

const initialState = {
  receivingItemReasonList: [],
}
export default function ReceivingItemReasonsReducer(state = initialState, action) {
  switch (action.type) {
    case RECEIVING_ITEM_REASON_DATA:
      return { ...state, receivingItemReasonList: action.payload }
    default:
      return state
  }
}
